module.exports = __webpack_public_path__ + "img/75633.7ed45993.svg";